module.exports = __webpack_public_path__ + "img/play_bt.59291766.png";